import { rootApiSupplyBeam } from "../../api/rootApi";

export const bontonListingAPI = rootApiSupplyBeam.injectEndpoints({
    endpoints: (builder) => ({
        getBontonPicklistList: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/get-picklist-list`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
        getBontonOrderList: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/get-order-list`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
        getBontonInvoiceList: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/get-invoice-list`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
        getBontonListingItemDetails: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/get-listing-item-details`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
        getBontonMappedQrList: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/mapped-qr-listing`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
        getBontonQrMappingRecordList: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/bonton/qr-mapping-record-list`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.data,
                };
            },
        }),
    }),
});

export const {
    useGetBontonPicklistListMutation,
    useGetBontonOrderListMutation,
    useGetBontonInvoiceListMutation,
    useGetBontonListingItemDetailsMutation,
    useGetBontonMappedQrListMutation,
    useGetBontonQrMappingRecordListMutation,
} = bontonListingAPI;
